export const EDITOR_WORD_LIMIT = 2500

export const NOT_READY = 'Not ready'
export const NEEDS_TWEAKS = 'Needs tweaks'
export const ALL_SET = 'All set!'

export const GRAMMAR_IMG_HEIGHT = 150
export const GRAMMAR_IMG_WIDTH = 150
export const DEBOUNCE_SAVE_PAPER_TIME_PERIOD = 2000
export const DEBOUNCE_MANUAL_EDIT_TIME_PERIOD = 2000
export const WORDS = 'words'
export const UNTITLED = 'Untitled'
export const REVIEW = 'Review'

export enum FeedbackTab {
  NO_ACTIVE_TAB = -1,
  GRAMMAR_TAB = 0,
  PARAPHRASE_TAB = 1,
}

export const fullCheckTimeoutInMS = 180000
export const selectionCheckTimeoutInMS = 60000

export const QA_WORD_COUNT_LIMIT = 4 // synonym & rewrite word count limit
